export const Dealer_Details = "DEALER_DETAILS";
export const Attendences = "ATTENDENCES"
export const Activity_Details = "ACTIVITY_DETAILS"
export const IsUserCheckout = "IS_USER_CHECKOUT"
export const Dealer_Activity_Types = "DEALER_ACTIVITY_TYPES"
export const NEW_ACTIVITY = 'new_Activity'
export const GET_DEALER_BY_ID = 'get_dealer_by_id'
export const RESCHEDULE_ACTIVITY = 'reschedule_activity'
export const GET_SENIOR = 'get_senior'
export const APPROVE_AND_REJECT = 'approve_and_reject'
export const TAGGED_ALONG_LIST = 'tagged_along_list'
export const TAGGED_ALONG_BY_ID = 'tagged_along_by_id'
export const ADD_TAGGED_ALONG = 'add_tagged_along'
export const ACTIVITY_FILTER = 'activity_filter'
export const MEETING_RATING = 'meeting_rating'
export const HEALTH_CARD = 'health_card'
export const DEALER_PROFILE_DATA = 'DEALER_PROFILE_DATA'
export const GET_JUNIOR_LISTING_FOR_HOD = 'GET_JUNIOR_LISTING_FOR_HOD'
export const GET_SELF_LISTING = 'GET_SELF_LISTING'
export const SAVE_RATING_FOR_HOD = 'SAVE_RATING_FOR_HOD'
export const STAR_CHECK = 'STAR_CHECK'
export const EMAIL_DROPDOWN = 'EMAIL_DROPDOWN'
export const SM_DETAILS_BY_USER_ID = 'SM_DETAILS_BY_USER_ID'
export const RM_VIEW_DETAILS = 'RM_VIEW_DETAILS'
export const VERIFY_UCD_DEALER = 'VERIFY_UCD_DEALER'
export const UCD_DEALER_BY_ID = 'UCD_DEALER_BY_ID'
export const UCD_DEALER_SAVE = 'UCD_DEALER_SAVE'
export const OTP_GENERATION = 'OTP_GENERATION'
export const UCD_LIST = 'UCD_LIST'
export const FIRM_TYPE = 'FIRM_TYPE'
export const UCD_DEALER_UPDATE = 'UCD_DEALER_UPDATE'
export const GET_DEALER_POC='GET_DEALER_POC'
export const UPDATE_DEALER_POC='UPDATE_DEALER_POC'
export const CAR_BRAND = 'CAR_BRAND';
export const CAR_MODEL = 'CAR_MODEL';
export const CAR_VARIANT = 'CAR_VARIANT';
export const BANK_LIST = 'BANK_LIST';
export const CASES_BY_LSQ_DEALER_ID = 'CASES_BY_LSQ_DEALER_ID';
export const CASES_STATUS_UPDATE = 'CASES_STATUS_UPDATE';
export const ADD_CASE = 'ADD_CASE';
export const CASE_LIST = 'CASE_LIST';
export const CASE_BY_ID = 'CASE_BY_ID';
export const LOAN_APPLICATION_BY_ID = 'LOAN_APPLICATION_BY_ID';
export const LOAN_APPLICATION_UPDATE = 'LOAN_APPLICATION_UPDATE';
export const PAYMENT_RAISE = 'PAYMENT_RAISE';
export const LOAN_ACCOUNTS = 'LOAN_ACCOUNTS';
export const LOAN_UNDERTAKING = 'LOAN_UNDERTAKING';
export const APPROVAL_REQUEST = 'APPROVAL_REQUEST';
export const LOAN_TRANCHES = 'LOAN_TRANCHES';
export const PAYMENT_RAISE_UPDATE = 'PAYMENT_RAISE_UPDATE';
export const PAYOUT_DETAILS_UPDATE = 'PAYOUT_DETAILS_UPDATE';
export const GET_PAYOUT_DETAILS = 'GET_PAYOUT_DETAILS';
export const NEW_BANK_DETAILS = 'NEW_BANK_DETAILS';
export const UPDATE_TRANCHE_STATUS = 'UPDATE_TRANCHE_STATUS';
export const FORE_CLOSURE_ACCOUNT = 'FORE_CLOSURE_ACCOUNT';
export const VEHICLE_DETAILS = 'VEHICLE_DETAILS';
export const AGREEMENT_UCD_NOTIFICATION = 'AGREEMENT_UCD_NOTIFICATION';
export const AGREEMENT_UCD_VERIFIED = 'AGREEMENT_UCD_VERIFIED';
export const DEALER_APPROVED_LIST = "DEALER_APPROVED_LIST";
export const RC_CASE_BY_ID = "RC_CASE_BY_ID";
